import { render, staticRenderFns } from "./ThgPromotionListItem.vue?vue&type=template&id=14f7a9a1"
import script from "./ThgPromotionListItem.vue?vue&type=script&lang=ts"
export * from "./ThgPromotionListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports